import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/edit_params.svg'
import _imports_2 from '../assets/code.svg'
import _imports_3 from '../assets/save.svg'


const _withScopeId = n => (_pushScopeId("data-v-f58ad72c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-inner" }
const _hoisted_2 = {
  class: "header-table",
  cellspacing: "0"
}
const _hoisted_3 = { class: "icon-column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "icon-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "edit params logo"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "heading" }, "Edit Node", -1))
const _hoisted_10 = { class: "icon-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "icon-column" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "edit-options-div" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Programming Language", -1))
const _hoisted_18 = { class: "language-select-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select Template", -1))
const _hoisted_20 = {
  name: "templates",
  id: "",
  class: "template-select"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Subscribers", -1))
const _hoisted_22 = { class: "topic-display-table" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Publishers", -1))
const _hoisted_25 = { class: "topic-display-table" }
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onKeypress: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.saveAndExit()), ["enter"])),
        tabindex: "0"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveAndExit()))
                }, _hoisted_5)
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onShowEditParams')))
                }, _hoisted_8)
              ]),
              _hoisted_9,
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCode()))
                }, _hoisted_12)
              ]),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
                }, _hoisted_15)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "name-input",
              placeholder: "Enter node name...",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.name]
            ]),
            _hoisted_17,
            _createElementVNode("table", _hoisted_18, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  class: _normalizeClass(["language-select-box-left", { selected: !_ctx.languagePython }])
                }, [
                  _createElementVNode("button", {
                    class: "language-select-button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLanguage(false)))
                  }, " C/C++ ")
                ], 2),
                _createElementVNode("td", {
                  class: _normalizeClass(["language-select-box-right", { selected: _ctx.languagePython }])
                }, [
                  _createElementVNode("button", {
                    class: "language-select-button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setLanguage(true)))
                  }, " Python ")
                ], 2)
              ])
            ]),
            _hoisted_19,
            _createElementVNode("select", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ncStore.nodeTemplates, (template) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: template.name
                }, _toDisplayString(template.name), 1))
              }), 128))
            ]),
            _hoisted_21,
            _createElementVNode("table", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeToEdit.subscribers, (subscriber) => {
                return (_openBlock(), _createElementBlock("tr", { key: subscriber }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.globalStore.getTopic(subscriber)?.name), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "icon-button red-button",
                      title: "Remove publisher",
                      onClick: ($event: any) => (_ctx.nodeToEdit.removeSubscriber(subscriber))
                    }, [
                      _createVNode(_component_fa, { icon: "xmark" })
                    ], 8, _hoisted_23)
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_24,
            _createElementVNode("table", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeToEdit.publishers, (publisher) => {
                return (_openBlock(), _createElementBlock("tr", { key: publisher }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.globalStore.getTopic(publisher)?.name), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "icon-button red-button",
                      title: "Remove publisher",
                      onClick: ($event: any) => (_ctx.nodeToEdit.removePublisher(publisher))
                    }, [
                      _createVNode(_component_fa, { icon: "xmark" })
                    ], 8, _hoisted_26)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "dialog-bg",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveAndExit()))
        })
      ], 32))
    : _createCommentVNode("", true)
}